import { trans } from '@spotahome/bff/client';

export const getCityName = cityId =>
  cityId ? trans(`landingpage.label.${cityId}`) : '';

export const getCityList = cityList =>
  cityList.reduce(
    (acc, currentCity) => ({
      ...acc,
      [currentCity.id]: {
        name: getCityName(currentCity.id),
        currencyIsoCode: currentCity.currencyIsoCode
      }
    }),
    {}
  );

export default {
  getCityName,
  getCityList
};
